module.exports = __webpack_public_path__ + "img/BG-优势特点.ef171d09.png";